import { ICellRenderer } from "ag-grid-enterprise";
import { ChangeDetectionStrategy, Component, computed, signal } from "@angular/core";
import { NgClass } from "@angular/common";
import { AccountingCurrencyPipe } from "../../pipes/accounting-currency.pipe";

@Component({
    selector: 'currency-cell-renderer',
    templateUrl: 'currency-cell-renderer.component.html',
    styleUrls: ['./currency-cell-renderer.component.scss'],
    imports: [NgClass, AccountingCurrencyPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
  export class CurrencyCellRendererComponent implements ICellRenderer {
    params!: any;
    public currencyValue = signal<number>(0);
    public negativeCurrencyCssClass = computed(() => this.currencyValue() < 0 ? 'negativeCurrency' : '');

    agInit(params: any): void {
      this.params = params;
      this.setParameters();
    }

    setParameters() {
      this.currencyValue.set(this.params.currencyValue);
    }

    refresh(params: any) {
      this.params = params;
      this.setParameters();
      return true;
    }
  }
